import PropTypes from 'prop-types'
import React from 'react'
import * as WebViewBridge from '@/checkout-instore-legacy/utils/WebViewBridge'
import { genericImportantEvent } from '@/checkout-instore-legacy/utils/EventHelper'

import NotifierLogoutMessage from './NotifierLogoutMessage'
import Prompt from './Prompt/index'

class Notifier extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      showDetails: false,
      errorReported: false,
      prompt: null,
    }
  }

  componentDidMount() {
    WebViewBridge.listen(this.onReceiveWebViewBridgeEvent)
  }

  componentWillUnmount() {
    WebViewBridge.unlisten(this.onReceiveWebViewBridgeEvent)
  }

  componentDidUpdate(prevProps) {
    const prevError = !!(
      prevProps.orderStoreError || prevProps.vendorStoreError
    )
    const currentError = !!(
      this.props.orderStoreError || this.props.vendorStoreError
    )

    if (prevError && !currentError) {
      this.setState({ showDetails: false })
    }
  }

  onReceiveWebViewBridgeEvent = (event) => {
    if (event.type === 'notify/prompt') {
      this.setState({ prompt: event.data })
    }
  }

  handleLogout = () => {
    this.props.dismissVendorNotifications()
    this.props.dismissOrderNotifications()
    this.props.router.push('/vendor/login')
  }

  render() {
    const { prompt } = this.state
    const { vendorStoreError } = this.props
    const { orderStoreError } = this.props
    const error = orderStoreError || vendorStoreError

    if (prompt) {
      genericImportantEvent('show-notifier-with-prompt', {
        context: 'Sale',
      })
      return (
        <Prompt
          message={prompt.message}
          options={prompt.options}
          onSelectOption={(index, option) => {
            if (prompt.bridgeResponseType) {
              WebViewBridge.sendEvent({
                type: prompt.bridgeResponseType,
                index: index,
                option: option,
              })
            }
          }}
        />
      )
    }

    if (!error) {
      return null
    }

    if (error && error.type && error.type === 'logoutMessage') {
      genericImportantEvent('show-notifier-with-logout-message', {
        context: 'Sale',
        error: error.toString(),
      })
      return (
        <NotifierLogoutMessage
          message={error.message}
          onClick={this.handleLogout}
        />
      )
    }

    return null
  }
}

Notifier.propTypes = {
  router: PropTypes.any,
  orderStoreError: PropTypes.object,
  vendorStoreError: PropTypes.object,
  dismissVendorNotifications: PropTypes.func.isRequired,
  dismissOrderNotifications: PropTypes.func.isRequired,
}

export default Notifier
